<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="报告维护频率" prop="reportFreq">
                    <el-select v-model="queryCondition.reportFreq" @change="reportFreqChange" clearable style="width:100%" placeholder="请选择">
                      <el-option :key="index" v-for="(item,index) in reportFreqLists" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="报告期限" prop="reportDates">
                    <el-select v-model="queryCondition.reportDates" multiple clearable style="width:100%" placeholder="请选择">
                      <el-option :key="index" v-for="(item,index) in reportDateLists" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="queryCondition.category3Code" clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                    <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="ASL Group" prop="aslGroupName">
                      <el-input v-model="queryCondition.aslGroupName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <el-select v-model="queryCondition.status" clearable placeholder="请选择" style="width:100%" filterable class="multiple_sel">
                        <el-option :key="index" v-for="(item,index) in statusOption" :label="item.chineseValue" :value="item.code"></el-option>
                      </el-select>
                      <!-- <ic-select table="TT_RMC_PROTEIN_MEDICINE_USAGE" filterable field="STATUS" clearable v-model="queryCondition.status"  style="width:100%"></ic-select> -->
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="RMC_PROT_MEDUSAGE_ADD" class="btn" type="primary" @click="addList">新增</el-button>
        <el-button v-acl="RMC_PROT_MEDUSAGE_DELETE" class="btn" type="danger" @click="onDel">删除</el-button>
        <el-button v-acl="RMC_PROT_MEDUSAGE_COPY" class="btn" type="primary" @click="onCopy">复制</el-button>
        <el-button v-acl="RMC_PROT_MEDUSAGE_ADD,RMC_PROT_MEDUSAGE_ITEM_UPDATE" class="btn" type="primary" @click="onImport">整单导入</el-button>
        <!-- <el-button v-acl="RMC_PROT_MEDUSAGE_EXPORT" class="btn" type="primary" @click="exportData">导出</el-button> -->
        <el-dropdown split-button type="primary" placement="bottom" v-acl="RMC_PROT_MEDUSAGE_EXPORT">
          报表导出
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button class="dropdownItemBtn" size="mini" type="primary" @click="exportData" v-acl="RMC_PROT_MEDUSAGE_EXPORT">导出</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button class="dropdownItemBtn" size="mini" type="primary" @click="porkDDownload" v-acl="RMC_PROT_MEDUSAGE_EXPORT">季度导出</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-row>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all">
          <commonTable :ref="commonTable" :data.sync="tableData" @goToDetail="goToDetail" @selectionChange="selectionChange"></commonTable>
        </el-tab-pane>
        <el-tab-pane label="Poultry(月度)" name="poultry">
          <commonTable ref="commonTable" :data.sync="tableData" @goToDetail="goToDetail" @selectionChange="selectionChange"></commonTable>
        </el-tab-pane>
        <el-tab-pane label="Pork(季度)" name="pork">
          <commonTable :showStatus.sync="showStatus" ref="commonTable" :data.sync="tableData" @goToDetail="goToDetail" @selectionChange="selectionChange"></commonTable>
        </el-tab-pane>
        <div class="pagination">
          <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page.sync="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size.sync="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
          </el-pagination>
        </div>
      </el-tabs>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <div slot="title" class="header-title">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">更新状态 <span style="font-weight: normal;margin-left:10px;font-size:12px;">如果无更新时，请先在日期后点击确认</span> </p>
        </div>
      </div>
      <updateDialog @close="handleClose"></updateDialog>
    </el-dialog>
    <el-dialog title="新增药品用量" :visible.sync="addDialogVisible" width="30%" @close="onCancel" class="fpa">
      <el-row type="flex" justify="center">
        <el-col :span="2">类型: </el-col>
        <el-col :span="20">
          <el-radio v-model="radio" label="M" v-acl="RMC_DATAPERM_POULTRY">月度Poultry</el-radio>
          <el-radio v-model="radio" label="Q" v-acl="RMC_DATAPERM_PORK">季度Pork</el-radio>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" style="margin-top:10px">
        <el-button class="btn" type="primary" @click="onConfirm">确认</el-button>
        <el-button class="btn" type="plain" @click="onCancel">取消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="整单导入" :visible.sync="importDialogShow" width="40%" :before-close="handleCloseImport" class="fpa">
      <importDialog v-if="importDialogShow" :sign="sign" @handleCloseImport="handleCloseImport"></importDialog>
    </el-dialog>
    <el-dialog title="选择季度" :visible.sync="dialogQuarterVisible" width="30%" :close-on-click-modal="false" @close="onCancelQuarter">
      <quarterDialog ref="quarterDialog" :type="type" @onCancelQuarter="onCancelQuarter"></quarterDialog>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import updateDialog from '@/components/page/RMC/Protein/rmcDrugList/updateDialog'
import medicineDosage from "@/api/rmcProtein/medicineDosage";
import proteinDrug from "@/api/rmcProtein/drug";
import { fileService } from "@/api/common/file-utils";
import prodMedicine from "@/api/rmcProduce/prodMedicine";
import commonTable from './commonTable.vue'
import importDialog from './import.vue'
import quarterDialog from "../../Produce/public/quarterDialog.vue";

export default {
  name: '',
  components: {
    updateDialog,
    IcSelect,
    commonTable,
    importDialog,
    quarterDialog
  },
  data() {
    return {
      dialogQuarterVisible: false,
      importDialogShow: false,
      radio: "",
      addDialogVisible: false,
      activeName: 'all',
      identity: localStorage.getItem('ms_emplFlag'),
      dialogVisible: false,
      reportDateLists: [],
      categoryList2: [],
      category3List: [],
      statusList: [],
      queryCondition: {
        reportFreq: "",
        reportDates: [],
        category3Code: "",
        sponsorName: "",
        aslGroupName: "",
        pageNum: 1,
        pageSize: 15,
        status: "",
      },
      isShow: false,
      showDetailDialog: false,
      formData: null,
      totalCount: 0,
      statusView: "",
      statusOption: [],
      reportFreqLists: [],
      ms_roles: JSON.parse(localStorage.getItem('ms_roles')),
      tableData: [],
      sign: "",
      multipleSelection: [],
      showStatus: false,
      type: "",
    }
  },
  created() {
    let qspiInfo = JSON.parse(sessionStorage.getItem('qspiInfo'))
    let queryData = this.$store.state.asl.skipQuery
    if (qspiInfo) {
      if (qspiInfo.SPONSOR_NAME) {
        this.$set(this.queryCondition, 'sponsorName', qspiInfo.SPONSOR_NAME)
      }
      if (qspiInfo.AUDIT_STATUS) {
        this.$set(this.queryCondition, 'status', qspiInfo.AUDIT_STATUS)
      }
    }
    if (queryData.aslGroupName) {
      this.$set(this.queryCondition, 'aslGroupName', queryData.aslGroupName)
    }
    this.getStatusList()
    this.getReportDateOptions()
    this.getdCategory3()
    this.getReportFreqLists()
  },
  mounted() {
    this.queryData();
  },
  destroyed() {
    this.$store.dispatch('saveQueryData', {})
    sessionStorage.setItem('qspiInfo', null)
  },
  methods: {
    onImport() {
      this.sign = 'whole'
      this.importDialogShow = true
    },
    handleCloseImport() {
      this.importDialogShow = false
      this.queryData()
    },
    pageSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    getStatusList() {
      prodMedicine.getStatusList({
        "TT_RMC_PROTEIN_MEDICINE_USAGE:STATUS": "TT_RMC_PROTEIN_MEDICINE_USAGE:STATUS",
      }).then((res) => {
        if (this.ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS') !== -1) {
          this.statusOption = res["TT_RMC_PROTEIN_MEDICINE_USAGE:STATUS"].filter(ele => {
            return ele.code != "DRAFT"
          })
        } else {
          this.statusOption = res["TT_RMC_PROTEIN_MEDICINE_USAGE:STATUS"];
        }
      })
    },
    getReportFreqLists() {
      medicineDosage.getReportFreqOptions().then(res => {
        console.log("GY🚀 ~ file: query.vue:199 ~ medicineDosage.getReportFreqOptions ~ res:", res);
        if (res.code == '200') {
          this.reportFreqLists = res.data
        }
      })
    },
    getdCategory3() {
      proteinDrug.getdCategory3().then((res) => {
        this.category3List = res.data.filter((v) => {
          return v.cascadeKey == 'protein'
        })
      })
    },
    reportFreqChange(val) {
      console.log("GY🚀 ~ file: query.vue:214 ~ reportFreqChange ~ val:", val);
      this.getReportDateOptions(val)
    },
    getReportDateOptions(reportFreq) {
      medicineDosage.getReportDateOptions(reportFreq).then((res) => {
        if (res.code == '200') {
          this.reportDateLists = res.data
        }
      })
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1
      }
      this.$refs.commonTable.tableData = []
      if (this.activeName == 'poultry') {
        this.$set(this.queryCondition, 'reportFreq', 'M')
        this.$set(this.queryCondition, 'category3Code', '10101')
      } else if (this.activeName == 'pork') {
        this.$set(this.queryCondition, 'reportFreq', 'Q')
        this.$set(this.queryCondition, 'category3Code', '10103')
      } else {
        this.$set(this.queryCondition, 'reportFreq', this.queryCondition.reportFreq)
        this.$set(this.queryCondition, 'category3Code', this.queryCondition.category3Code)
      }
      medicineDosage.getMedicineUsage(this.queryCondition).then((res) => {
        console.log("GY🚀 ~ file: query.vue:259 ~ medicineDosage.getMedicineUsage ~ this.activeName:", this.activeName);
        console.log("GY🚀 ~ file: query.vue:211 ~ medicineDosage.getMedicineUsage ~ res:", res);
        if (this.activeName == 'all') {
          this.tableData = res.resultData
          this.totalCount = res.totalCount
        } else if (this.activeName == 'poultry') {
          // 只展示月度的poultry数据
          if (res.resultData.length > 0) {
            // .filter(ele => ele.reportFreq == 'M' && ele.category3Code == '10101')
            this.tableData = res.resultData
            this.totalCount = res.totalCount
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        } else if (this.activeName == 'pork') {
          // 只展示季度的pork数据
          if (res.resultData.length > 0) {
            // .filter(ele => ele.reportFreq == 'Q' && ele.category3Code == '10103')
            this.tableData = res.resultData
            this.totalCount = res.totalCount
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        }
        console.log("GY🚀 ~ file: query.vue:275 ~ medicineDosage.getMedicineUsage ~  this.tableData:", this.tableData);
      })
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    handleClick(tab, event) {
      console.log("GY🚀 ~ file: query.vue:235 ~ handleClick ~ event:", event);
      console.log("GY🚀 ~ file: query.vue:235 ~ handleClick ~ tab:", tab);
      // console.log("GY🚀 ~ file: query.vue:235 ~ handleClick ~ all:", this.$refs.all);
      // console.log("GY🚀 ~ file: query.vue:235 ~ handleClick ~ poultry:", this.$refs.poultry);
      // console.log("GY🚀 ~ file: query.vue:235 ~ handleClick ~ pork:", this.$refs.pork);
      // console.log("GY🚀 ~ file: query.vue:235 ~ handleClick ~ this.$refs.all.$refs.pagination.pageSize:", this.$refs.all.$refs.pagination.pageSize);
      // console.log("GY🚀 ~ file: query.vue:235 ~ handleClick ~ this.$refs.poultry.$refs.pagination.pageSize:", this.$refs.poultry.$refs.pagination.pageSize);
      // console.log("GY🚀 ~ file: query.vue:235 ~ handleClick ~ this.$refs.pork.$refs.pagination.pageSize:", this.$refs.pork.$refs.pagination.pageSize);
      this.$nextTick(() => {

        this.activeName = tab.name
        // this.$refs.commonTable.pageSize = 15
        // this.$refs.commonTable.pageNum = 1
        // this.$refs.commonTable.$refs.pagination.pageSize = 15
        // this.$refs.commonTable.$refs.pagination.currentPage = 1
        this.queryCondition.pageSize = 15
        this.queryCondition.pageNum = 1
        this.queryCondition.reportDates = []

        switch (tab.name) {
          case 'all':
            this.$set(this.queryCondition, 'reportFreq', '')
            this.$set(this.queryCondition, 'category3Code', '')
            this.showStatus = true
            this.queryData()
            this.getReportDateOptions()
            break;
          case 'poultry':
            this.$set(this.queryCondition, 'reportFreq', 'M')
            this.$set(this.queryCondition, 'category3Code', '10101')
            this.showStatus = true
            this.queryData()
            this.getReportDateOptions(this.queryCondition.reportFreq)
            break;
          case 'pork':
            this.$set(this.queryCondition, 'reportFreq', 'Q')
            this.$set(this.queryCondition, 'category3Code', '10103')
            this.showStatus = false
            this.queryData()
            this.getReportDateOptions(this.queryCondition.reportFreq)
            break;
        }
      })
    },
    onCopy() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择数据后再操作')
        return false
      } else if (this.multipleSelection.length > 2) {
        this.$message.error('只能选择一条数据复制')
        return false
      } else {
        if (this.multipleSelection[0].reportFreq == 'Q' && this.multipleSelection[0].category3Code == '10101') {
          this.$message.error('无法复制Poultry季度的数据,需按照月度维护!')
          return false
        } else {
          this.$router.push({
            path: "/rmcProtMedUsage/detail",
            query: {
              id: this.multipleSelection[0].ttRmcProteinMedicineUsageId,
              sign: "copy",
              type: this.multipleSelection[0].reportFreq
            }
          })
        }
      }
    },
    goToDetail(ttRmcProteinMedicineUsageId, reportFreq) {
      console.log("GY🚀 ~ file: query.vue:326 ~ goToDetail ~ reportFreq:", reportFreq);
      console.log("GY🚀 ~ file: query.vue:258 ~ goToDetail ~ ttRmcProteinMedicineUsageId:", ttRmcProteinMedicineUsageId);
      this.$router.push({
        path: "/rmcProtMedUsage/detail",
        query: {
          id: ttRmcProteinMedicineUsageId,
          sign: "edit",
          type: reportFreq
        }
      })
    },
    onReset() {
      this.queryCondition = {
        reportDates: [],
        reportFreq: "",
        category3Code: "",
        sponsorName: "",
        aslGroupName: "",
        pageNum: 1,
        pageSize: 15,
        status: "",
      }
      switch (this.activeName) {
        case 'all':
          this.$set(this.queryCondition, 'reportFreq', '')
          this.$set(this.queryCondition, 'category3Code', '')
          this.queryData()
          break;
        case 'poultry':
          this.$set(this.queryCondition, 'reportFreq', 'M')
          this.$set(this.queryCondition, 'category3Code', '10101')
          this.queryData()
          this.getReportDateOptions(this.queryCondition.reportFreq)
          break;
        case 'pork':
          this.$set(this.queryCondition, 'reportFreq', 'Q')
          this.$set(this.queryCondition, 'category3Code', '10103')
          this.queryData()
          this.getReportDateOptions(this.queryCondition.reportFreq)
          break;
      }
      this.queryCondition.pageNum = 1
      this.queryData();
      this.getReportDateOptions(this.queryCondition.reportFreq)
    },
    addList() {
      this.addDialogVisible = true
      // this.$router.push({
      //   path: "/rmcProtMedUsage/detail",
      // })
    },
    onConfirm() {
      if (this.radio) {
        this.$router.push({
          path: "/rmcProtMedUsage/detail",
          query: {
            // reportFreq: this.radio,
            // category3Code: this.radio == 'M' ? '10101' : '10103',
            type: this.radio,
            sign: "add",
          }
        })
      } else {
        this.$message.error('请选择类型')
        return false
      }
    },
    onCancel() {
      this.addDialogVisible = false
    },
    onDel() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择数据后再操作')
      } else {
        let isCreate = this.multipleSelection.some((v) => {
          return v.status != 'DRAFT'
        })
        if (isCreate) {
          this.$message.error("仅可删除草稿状态的清单")
        } else {
          this.$confirm('请确认是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass: 'colorBtn',
            cancelButtonClass: 'btn_custom_cancel',
            type: 'warning'
          }).then(() => {
            let params = {
              proteinMedicineUsageIds: []
            }
            this.multipleSelection.forEach((v) => {
              params.proteinMedicineUsageIds.push(v.ttRmcProteinMedicineUsageId)
            })
            medicineDosage.deleteMedicineUsage(params).then((res) => {
              if (res.code == 200) {
                this.$message.success('删除成功')
                this.queryData()
              } else {
                this.$message.error(res.msg)
              }
            })
          })
        }
      }
    },
    exportData() {
      let ids = []
      this.multipleSelection.forEach((v) => {
        ids.push(v.ttRmcProteinMedicineUsageId)
      })
      this.queryCondition.proteinMedicineUsageIds = ids
      medicineDosage.exportMedicineUsage(this.queryCondition).then((res) => {
        fileService.respToFile(res, 'Protein_药品用量.xlsx');
      })
      console.log("导出")
    },
    porkDDownload() {
      this.dialogQuarterVisible = true;
      this.type = "protein_rmcProtMedUsage";
      this.$refs["quarterDialog"].$refs["quarterForm"].clearValidate();
    },
    onCancelQuarter() {
      this.dialogQuarterVisible = false;
      this.$refs["quarterDialog"].$refs["quarterForm"].resetFields();
    },
    handleClose() {
      this.dialogVisible = false
      this.queryData()
    },

  },
  extends: commonFunction
}
</script>
<style scoped >
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
